import angular from 'angular'
import Home from './home/home'
import About from './about/about'
import Welcome from './welcome/welcome'
import Statistics from './statistics/statistics'
import Privacy from './policies/privacy/privacy'
import Terms from './policies/terms/terms'
// import BookMobile from './bookMobile/bookMobile'
// import ContributorMobile from './contributorMobile/contributorMobile'
import Cookies from './cookies/cookies'

const componentModule = angular.module('app.components', [
    Home,
    About,
    Welcome,
    Statistics,
    Privacy,
    Terms,
    // BookMobile,
    // ContributorMobile,
    Cookies
])

    .name

export default componentModule



// WEBPACK FOOTER //
// ./client/app/components/components.js